import React from "react";
import { FaBriefcase, FaGraduationCap, FaCalendarAlt } from "react-icons/fa";

const TIMELINE_DATA = [
  {
    type: "work",
    title: "Java Spring Boot Developer",
    company: "Impiger Technologies",
    duration: "2022 - Present",
    details: [
      "Develop and maintain scalable enterprise web applications using Java, Spring Boot, and Microservices.",
      "Involved in the Recruitment Management Platform for Xpheno, building real-time notifications and implementing Typesense search.",
      "Developed the Supplier Management System for Rane utilizing PHP, Laravel, and JavaScript.",
      "Integrated system solutions with Docker, Keycloak, Redis caching, and relational databases."
    ]
  },
  {
    type: "education",
    title: "Bachelor of Computer Applications (BCA)",
    company: "Undergraduate Education",
    duration: "2019 - 2022",
    details: [
      "Completed UG degree in Computer Applications.",
      "Laid a strong foundation in Programming Languages (C, C++, Java), Web Technologies, and Data Structures."
    ]
  }
];

function Timeline() {
  return (
    <div className="custom-timeline-container">
      <h2 className="tech-section-title text-center mb-5" style={{ borderLeft: "none", textAlign: "center !important" }}>
        Work Experience & Education
      </h2>
      <div className="custom-timeline">
        {TIMELINE_DATA.map((item, idx) => (
          <div key={idx} className={`timeline-item ${item.type === "work" ? "timeline-work" : "timeline-edu"}`}>
            <div className="timeline-icon-container">
              {item.type === "work" ? (
                <FaBriefcase className="timeline-main-icon" />
              ) : (
                <FaGraduationCap className="timeline-main-icon" />
              )}
            </div>
            <div className="timeline-content-card">
              <span className="timeline-date">
                <FaCalendarAlt /> {item.duration}
              </span>
              <h3 className="timeline-title">{item.title}</h3>
              <h4 className="timeline-company purple">{item.company}</h4>
              <ul className="timeline-details-list">
                {item.details.map((detail, dIdx) => (
                  <li key={dIdx}>{detail}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Timeline;
